import api from 'actions/api'
import uuidv1 from 'uuid/v1'
import { showError } from 'actions'
import { showMessage } from '../../../../actions/index'

export const PAYMENT_INIT_LOADING_ACTION = 'payment_init_loading'
export const PAYMENT_INIT_INFORMATION_ACTION = 'payment_init_information'
export const TOGGLE_PAYMENT_INFORMATION_COMPONENT_ACTION = 'toggle_payment_information_component'
export const SAVE_CONTRACT_CODES = 'save_contract_codes'


const INIT_PAYMENT_API = '/bank-transfer/init-payment'
const GET_MY_CONTRACTS_API = '/merchant-util/my-contracts'

export const togglePaymentLoading = loading => {
  return {
    type: PAYMENT_INIT_LOADING_ACTION,
    payload: loading,
  }
}

export const saveChargingCodes = contractCodes => {
  return {
    type: SAVE_CONTRACT_CODES,
    payload: contractCodes,
  }
}

export const togglePaymentInformationComponent = visible => {
  return {
    type: TOGGLE_PAYMENT_INFORMATION_COMPONENT_ACTION,
    payload: visible,
  }
}

export const storePaymentInitData = data => {
  return {
    type: PAYMENT_INIT_INFORMATION_ACTION,
    payload: data,
  }
}

export const timeOutTransaction = () => dispatch => {
  completeTransaction(false, dispatch)
}

export const processTransactionPush = transactionNotification => dispatch => {
  const { paymentStatus, amountPaid } = transactionNotification
  if (paymentStatus === 'PAID' || paymentStatus === 'OVERPAID') {
    completeTransaction(true, dispatch)
  } else {
    showMessage('Payment Received', `a payment of ${amountPaid} was just received`)
  }
}

const completeTransaction = (status, dispatch) => {
  dispatch(togglePaymentInformationComponent(false))
  if (status) {
    showMessage('Success', 'Transaction Successful')
  } else {
    showMessage('Timeout', 'Transaction Timed Out', 'error')
  }
}

export const getContractCodes = () => dispatch => {
  dispatch(
    api.get(
      GET_MY_CONTRACTS_API,
      {},
      response => {
        dispatch(saveChargingCodes(response.data.responseBody))
      },
      error => {},
    ),
  )
}

export const getBaseWebSocketURL = () => {
  const baseSocketURL =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:9091'
      : 'http://pe.monnify.test.teamapt.com'

  return baseSocketURL
}

export const initializePayment = request => (dispatch, getState) => {
  const contractCode = getState().paymentSimulator.contractCodes[0].code

  const paymentReference = uuidv1()
  const initpaymentRequest = {
    contractCode: contractCode,
    amount: request.amount,
    customerName: 'John Doe',
    customerEmail: 'johndoe@customer.com',
    customerPhone: '2348123423429',
    customerId: '123456789',
    paymentReference: paymentReference,
    paymentDescription: request.description,
    currencyCode: 'NGN',
  }
  dispatch(storePaymentInitData(null))
  dispatch(togglePaymentLoading(true))
  dispatch(togglePaymentInformationComponent(false))

  dispatch(
    api.post(
      INIT_PAYMENT_API,
      initpaymentRequest,
      response => {
        dispatch(togglePaymentLoading(false))
        //show component screen
        dispatch(togglePaymentInformationComponent(true))
        dispatch(storePaymentInitData(response.data.responseBody))
        //trackPayment(paymentReference, dispatch)
      },
      error => {
        showError(error)
        dispatch(togglePaymentLoading(false))
      },
    ),
  )
}



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/actions/index.js